"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isBrowser = true;
exports.default = isBrowser;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/datocms-client/lib/forceIsBrowser.js
// module id = 124
// module chunks = 0